export const DOMAIN_NAME={
  "jagran": "Lw7E5F35CzxG9Q4RzetXzB60ZEqol2zaf40aJvkeffpo9oObxEzhdvEXATcGPvqx",
  "english.jagran": "jbWwebjKQisWQ3GuhyykCHT9BjOmGKW4mx2RL0zzAVwc8QAGMcKvyhcsW8Fg9E63",
//   "prime.jagran": "sGmQpgRMcE36IF1zIeTeHRshjTPXWIIDKt8dH4BLAWhUgswh349KrUxCBez6TYxl",
//   "jagrantv": "4TQWJI23wTC9zrdEf7WTS4zXYar69l6ODaktptAiuh2CV547Dv3Vo0HeyYrQWZCl",
  "gujaratijagran": "hdh8E0yJ2Ct7H1W5grEPDF9SEJlhM6IYHRv5F9pTvAuBTqjtL4TOX3SwHw32i9CO",
  "jagranjosh": "6vMpHwzTFvjRG2wgSe30wvbTvZVeatHkEXr3TEJYSIO9LUm12dRhTxuiaMEdprGQ",
//   "joshcollege": "1OFa7blmUFsVt7aM3AjkXxPRcbrJkPah185r6oxuoWX4aLkAVwLdfVfHEoqBkuLX",
  "punjabijagran": "9VpqkIdGvdr7h8ksElWR4RaH4KruARP0dE6QMBpCCao4BJg4qMUk6vOHTyKG3sqo",
//   "topdealsjagran": "ik020fu0ltiQgOf6tiThBjfVp0jtKcrvAkccJHSvQPIuPHdoPZBiMjDoim9lYWVg",
//   "electionjagran": "83ACdmFa4tpJ5KkJP0Y4Ii49rOUxzmOZlkEBP3hPDdg7Wtihs2UYdkFtOQ52ESVl",
//   "election-englishjagran": "ubeaYJqprlQfYfKdQEBpx9XC48PDu7oaft4RrfjgUmt7dIrhIfOdBpeP3yhX2JJm",
  "marathijagran": "Q6P5sPR703b2oSw7OBWti950a6wF9aYesx9bQBXx4meutugUxdDwgf5L8kspzuGr",
  "hindi-herzindagi": "oFYycBVuddU3yWUJoYMGuCKFFQXz9Q63Cghtf8FFRuPVeL4hcVV949q4F6tyodBB",
  "english-herzindagi": "3hjx0osFRGuTBJxKUS5fMLmFelt6KHvRCYuxtu5mYLBLHbpATO8Ztkao7hML0lWv",
  "tamil-herzindagi": "MsHVCuvhY7jASDzxZ2sETRa6fjj4vLA21jQb4e3YUbJT1cm7GlJyDFQdILSL2EGP",
  "hindi-onlymyhealth": "ofrLDhsyFq8dykmT8FWbm1KqWB5OzlposWpao7OTCFm815Uye4uCxmCv7vMWP8Vs",
  "english-onlymyhealth": "355ZZdv4iTWidxYYBvIkJ1lxalrEaXsOpyRKrkRiWC5FcEVzxgHqdBuIAd4vU099",
  "tamil-onlymyhealth": "j96VZzAJ2qYbEeRAICFIqzAe7cKUo6IKrTFfaYDa8tbtcYV8Mx7AHK6IiTHFDY5G",
  "naidunia": "clAa6IPOFXLFQgyKGubb2k48TwCrOu9L69xyJkmtspCSlwsKY0RQR6XfuEQzPrVa",
//   "vishvasnews": "c19GcS4efXAyJr0Pth0IMV3Vs6kiey8pc4FdMO8CaLhg0cUeixAzMQiSJsSYROEE",
//   "electionnaidunia": "5gOCmhOVpTr5kPDqf4R4LbbYuhI4VyMxd7eWADTsvRDvVRgVSGak2L7MLSUcoHa2"
}
export const DOMAIN_ID={
  "english.jagran": 5,
  "prime.jagran": 6,
  "hindi-onlymyhealth": 9,
  "english-herzindagi": 10,
  "tamil-herzindagi": 11,
  "jagran": 12,
  "english-onlymyhealth": 15,
  "tamil-onlymyhealth": 16,
  "naidunia": 18,
  "gujaratijagran": 19,
  "vishvasnews": 20,
  "jagranjosh": 22,
  "punjabijagran": 24,
  "marathijagran": 29
}